// src/components/feature/ShippingTips.tsx
//
// Small educational card. Cites `~/.hermes/skills/domain/emarketing/`
// for the marketing angle on post-install touches, and
// `docs/proposals/vendor-ordering-automation.md` for the source
// of the agent pipeline. Designed to be quietly informative on the
// shipping tab without being noisy.

import { BookOpen } from "lucide-react";
import { useTranslation } from "react-i18next";

export function KnowledgeTipCard() {
  const { t } = useTranslation();
  return (
    <div className="rounded-md border border-border bg-bg-panel/40 p-4 text-[11px] leading-relaxed text-fg-tertiary">
      <div className="mb-1 flex items-center gap-1.5 text-fg-secondary">
        <BookOpen className="h-3.5 w-3.5" strokeWidth={1.5} />
        <span className="text-[10px] font-510 uppercase tracking-wider">
          {t("admin.shipping.tip.title")}
        </span>
      </div>
      <p>{t("admin.shipping.tip.body")}</p>
    </div>
  );
}
